const focusToggle = require('./focusToggle')
const ToggleButtons = require('./toggle-buttons')
const ToggleTranslationsMobile = require('./toggle-translations-mobile')

module.exports = ({ scope = document } = {}) => {
  const headerDropdown = scope.querySelector('.hse-header-dropdown')
  if (headerDropdown) {
    ToggleButtons('.hse-header-dropdown__')
    ToggleTranslationsMobile()
    focusToggle('.hse-header-dropdown__')
  }
}
